var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"app-provider"},[(_vm.loaded)?_c('app-content',{key:_vm.reloadKey}):_vm._e(),(_vm.toastMessage)?_c('app-toast',{attrs:{"message":_vm.toastMessage}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }